import { useQuery } from "urql";

import {
  GetIdpFdDocument,
  QueryIdpFdDocumentArgs,
} from "../../../graphql/generated.ts";

export function useIDPResult({ id }: QueryIdpFdDocumentArgs) {
  return useQuery({
    query: GetIdpFdDocument,
    variables: { id: Number(id) },
    pause: !id,
  });
}
